<div class="card kpi-purple">
    <div class="card-body kpi-card">
        <h5 class="card-title">Ancienneté <i class="fa fa-question-circle" matTooltipClass="tooltip-button" matTooltip="Il s’agit de la toute première date de publication de l’annonce, et non pas la dernière mise à jour (comme sur les sites immobiliers classiques)."></i></h5>
        <p class="card-value text-big-value">
            <ng-container *ngIf="preview">-</ng-container>
            <ng-container *ngIf="!preview">
            {{ favorite.ad.first_publication_date }}
            </ng-container>
        </p>
    </div>
</div>
